import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { findAll } from "@/apis/admin";
import Router from "@/constants/router";
import { AdmAuth, Yn } from "@/constants/code";
import { AdmDto } from "@/dto/AdmDto";

export default function useList() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [count, setCount] = useState<number>(0);
  const [list, setList] = useState<AdmDto[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleGoToCreate = () => {
    navigate(Router.AdminsCreate);
  };

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      const page = searchParams.get("page") || 1;
      const limit = searchParams.get("limit") || 10;
      const keyword = searchParams.get("keyword") || undefined;
      // , 로 들어오는 경우 배열로 변환
      const admAuth =
        searchParams.get("admAuth") === ""
          ? []
          : (searchParams.get("admAuth")?.split(",") as AdmAuth[]) || undefined;
      const useYn =
        searchParams.get("useYn") === ""
          ? []
          : (searchParams.get("useYn")?.split(",") as Yn[]) || undefined;

      const res = await findAll({
        page: +page,
        limit: +limit,
        keyword,
        admAuth,
        useYn,
      });

      setCount(res.count);
      setPage(res.page);
      setLimit(res.limit);
      setList(res.list);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  }, [searchParams]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    count,
    page,
    limit,
    list,
    handleGoToCreate,
    isLoading,
  };
}
